import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { FC } from "react";

import styles from "./styles";

interface CustomChipProps {
  value?: string | null;
  variant?: "success" | "default";
}

const CustomChip: FC<CustomChipProps> = ({ value, variant = "default" }) => {
  if (!value) {
    return;
  }

  return (
    <Box
      sx={{ ...styles.wrapper, ...(variant === "success" ? { color: "#37C390", borderRadius: "4px" } : {}) }}
    >
      <Box sx={{ ...styles.dot, ...(variant === "success" ? { backgroundColor: "#37C390" } : {}) }} />
      <Typography>{value}</Typography>
    </Box>
  );
};

export default CustomChip;
